import Vue from 'vue'
import Router from 'vue-router'
import Herd from '@/components/Herd'
import Settings from '@/components/Settings'
import Print from '@/components/Print'


Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Herd',
      component: Herd
    },
    {
      path: '/wydruk',
      name: 'Print',
      component: Print
    },
    {
      path: '/ustawienia/*',
      name: 'Ustawienia',
      component: Settings
    }
  ]
})
